function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillRule: "nonzero",
  d: "M9.714 9.714h4.857v82.572H9.714V9.714zm116.572 0h2.428v82.572h-2.428V9.714zm4.857 0H136v82.572h-4.857V9.714zm-12.143 0h4.857v82.572H119V9.714zm-12.143 0h4.857v82.572h-4.857V9.714zm-7.286 0h4.858v82.572H99.57V9.714zm-26.714 0h2.429v82.572h-2.429V9.714zm41.286 0h2.428v82.572h-2.428V9.714zM34 9.714h4.857v82.572H34V9.714zm7.286 0h2.428v82.572h-2.428V9.714zm21.857 0H68v82.572h-4.857V9.714zm14.571 0h2.429v82.572h-2.429V9.714zm-21.857 0h2.429v82.572h-2.429V9.714zm-4.857 0h2.429v82.572H51V9.714zm-34 0h4.857v82.572H17V9.714zm7.286 0h2.428v82.572h-2.428V9.714zm70.428 0h2.429v82.572h-2.429V9.714zm-12.143 0h4.858v82.572H82.57V9.714zM0 0h21.857v2.429H2.43v19.428H0V0zm145.714 0v21.857h-2.428V2.43h-19.429V0h21.857zM0 102V80.143h2.429V99.57h19.428V102H0zm145.714 0h-21.857v-2.429h19.429V80.143h2.428V102z"
});

function SvgNounBarcode1720931(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 146,
    height: 102,
    viewBox: "0 0 146 102",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNounBarcode1720931);
export default __webpack_public_path__ + "static/media/noun_barcode_1720931.6f2e07ae.svg";
export { ForwardRef as ReactComponent };